import { Pipe, PipeTransform } from '@angular/core';
import { API_PARAMS } from '../shared/constants/api.constants';

/**
 * 個人病史疾病管道：value添加前綴
 */
@Pipe({
  name: 'personalHistoryDisease',
  standalone: true,
})
export class PersonalHistoryDiseasePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    return `${API_PARAMS.QUESTIONNAIRE_DISEASE_PREFIX.PERSONAL}${value}`;
  }
}
